import { createStore, combineReducers } from 'redux';

import reducerLogin from './reducers/login';
import reducerUsers from './reducers/users';
import reducerCfdi from './reducers/cfdi_statuses';
import reducerCookie from './reducers/cookies';
import reducerChat from './reducers/chat';
import reducerTab from './reducers/tab';
import reducerRequisitions from './reducers/requisitions';
import reducerPurchaseOrders from './reducers/purchase_orders';

const appReducers = combineReducers({
    login: reducerLogin,
    users: reducerUsers,
    cfdi: reducerCfdi,
    cookies: reducerCookie,
    chat: reducerChat,
    tab: reducerTab,
    requisitions: reducerRequisitions,
    purchase_orders: reducerPurchaseOrders
});

export default createStore(appReducers);